/**
 * Centralizované `data-testid` konstanty pro E2E testy.
 *
 * Tento soubor MUSÍ být obsahově identický s:
 *   e2e/testIds.ts
 * (klíče i hodnoty). Liší se jen cesta importu.
 *
 * Workflow:
 * 1. Přidej konstantu sem
 * 2. Zkopíruj přesně stejný řádek do `e2e/testIds.ts`
 * 3. Použij v komponentě: `data-testid={TestIds.xxx}`
 * 4. Použij v E2E Page Objectu: `this.page.getByTestId(TestIds.xxx)`
 *
 * Pojmenování:
 * - Konstanta: `camelCase` — `signInButton`
 * - Hodnota (`data-testid`): `kebab-case` s feature prefixem — `signin-button`
 */
export const TestIds = {
	// Auth
	signInButton: "signin-button",
};
